/* FSP letters configurator v1.0 (13 Oct 2026)
   Order cut letters online: type the words, pick font, height, thickness, color and mounting, see the price, add to cart.
   Price per letter comes from the product's own variants (Thickness / Letter height / Letter type), so the cart price is
   always Shopify's price. The height is rounded UP to the next height in the table. Lowercase letters have their own,
   lower-priced variant. Files (outlined PDF, SVG, preview) go on the cart line like the FSP designer's.
   Needs: opentype.js, pdf-lib, the theme's fsp-font-*.b64.js outline files, and #fspl-product-json. */
(function () {
  'use strict';
  var VERSION = 'FSP letters v1.0';
  var root = document.getElementById('fsp-letters');
  if (!root || !window.opentype || !window.PDFLib) { return; }
  var PRODUCT = JSON.parse(document.getElementById('fspl-product-json').textContent);
  var ASSET = window.FSPL_ASSET_BASE || '';
  var $ = function (id) { return document.getElementById(id); };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function r1(x) { return Math.round(x * 10) / 10; }
  function fmtIn(x) { var v = Math.round(x * 4) / 4; var w = Math.floor(v), f = v - w; var fr = f === 0.25 ? '1/4' : f === 0.5 ? '1/2' : f === 0.75 ? '3/4' : ''; return (w ? w + (fr ? '-' : '') : '') + fr + '"'; }

  /* ---------- material (from the product) ---------- */
  var MATERIAL = /pvc/i.test(PRODUCT.handle) ? 'PVC' : 'acrylic';
  var NOUN = MATERIAL === 'PVC' ? 'flat cut PVC' : 'flat cut acrylic';

  /* ---------- variants: Thickness / Letter height / Letter type ---------- */
  var OPT = (PRODUCT.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  var iThick = OPT.findIndex(function (n) { return /thick/i.test(n); });
  var iHeight = OPT.findIndex(function (n) { return /height/i.test(n); });
  var iType = OPT.findIndex(function (n) { return /type|case/i.test(n); });
  function optVal(v, i) { return v['option' + (i + 1)]; }
  function inches(s) { s = String(s).replace(/"/g, '').trim(); var m = /^(\d+)-(\d+)\/(\d+)$/.exec(s); if (m) { return +m[1] + m[2] / m[3]; } m = /^(\d+)\/(\d+)$/.exec(s); if (m) { return m[1] / m[2]; } return parseFloat(s); }
  var TABLE = {};   // thickness -> [{h, cap: variant, low: variant}] sorted by height
  var THICKS = [];
  (PRODUCT.variants || []).forEach(function (v) {
    if (v.available === false) { return; }
    var t = optVal(v, iThick), h = inches(optVal(v, iHeight)), low = /lower/i.test(optVal(v, iType));
    if (!TABLE[t]) { TABLE[t] = {}; THICKS.push(t); }
    var row = TABLE[t][h] || (TABLE[t][h] = { h: h, label: optVal(v, iHeight) });
    row[low ? 'low' : 'cap'] = v;
  });
  Object.keys(TABLE).forEach(function (t) { TABLE[t] = Object.keys(TABLE[t]).map(function (k) { return TABLE[t][k]; }).filter(function (r) { return r.cap; }).sort(function (a, b) { return a.h - b.h; }); });
  THICKS.sort(function (a, b) { return inches(a.split(' ')[0]) - inches(b.split(' ')[0]); });

  /* ---------- fonts (the same files as the FSP designer) ---------- */
  var FONT_GROUPS = [
    ['Sans serif', ['Montserrat', 'Open Sans', 'Roboto', 'Inter', 'Poppins', 'Lato', 'Arimo', 'Raleway', 'Nunito', 'Manrope', 'Rubik', 'Quicksand', 'Plus Jakarta Sans', 'Work Sans', 'Figtree', 'Fira Sans', 'Glacial Indifference']],
    ['Bold & condensed', ['Oswald', 'Roboto Condensed', 'Bebas Neue', 'Anton', 'Archivo Black', 'Barlow Condensed', 'Fira Sans Condensed', 'Antonio', 'Hammersmith One', 'Black Ops One']],
    ['Serif', ['Playfair Display', 'Merriweather', 'Roboto Slab', 'Lora', 'Libre Baskerville', 'EB Garamond', 'Zilla Slab', 'Alfa Slab One']],
    ['Script', ['Dancing Script', 'Pacifico', 'Pinyon Script', 'Italianno']]
  ];
  var FONT_LABELS = { 'Arimo': 'Arimo (looks like Arial)' };
  var ONE_WEIGHT = { 'Bebas Neue': 1, 'Archivo Black': 1, 'Hammersmith One': 1, 'Pinyon Script': 1, 'Italianno': 1, 'Anton': 1, 'Black Ops One': 1, 'Alfa Slab One': 1, 'Pacifico': 1 };
  function fontSlug(fam) { return fam.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  var OT = {}, LOADING = {};
  function loadFont(fam, w) {
    var k = fam + '|' + w;
    if (OT[k]) { return Promise.resolve(OT[k]); }
    if (LOADING[k]) { return LOADING[k]; }
    LOADING[k] = fetch(ASSET + 'fsp-font-' + fontSlug(fam) + '-' + w + '.b64.js').then(function (r) {
      if (!r.ok) { throw new Error('font ' + fam + ' HTTP ' + r.status); }
      return r.text();
    }).then(function (t) {
      var bin = atob(t.replace(/[^A-Za-z0-9+\/=]/g, '')), u = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) { u[i] = bin.charCodeAt(i); }
      OT[k] = opentype.parse(u.buffer); return OT[k];
    }).catch(function (e) { delete LOADING[k]; throw e; });
    return LOADING[k];
  }

  /* ---------- colors ---------- */
  var COLORS = MATERIAL === 'PVC'
    ? [['White', '#ffffff'], ['Black', '#1a1a1a'], ['Gray', '#8a8d8f'], ['Navy', '#0c2340'], ['Blue', '#0057b8'], ['Red', '#c8102e'], ['Dark green', '#154734'], ['Brown', '#5c4033'], ['Tan', '#c8b08a'], ['Gold', '#b9975b']]
    : [['White', '#ffffff'], ['Black', '#1a1a1a'], ['Red', '#c8102e'], ['Blue', '#0057b8'], ['Navy', '#0c2340'], ['Green', '#2e7d32'], ['Yellow', '#ffd100'], ['Orange', '#ff6a13'], ['Gray', '#8a8d8f'], ['Brown', '#5c4033']];
  var MOUNTS = ['Flush to the wall (threaded studs)', 'Spaced off the wall (studs with spacers)', 'Double-sided tape (smooth walls, smaller letters)', 'Not sure, please advise'];

  /* ---------- state ---------- */
  var S = { text: 'Your Name', font: 'Montserrat', bold: true, height: 8, thick: THICKS.indexOf('1/4"') >= 0 ? '1/4"' : THICKS[0], color: COLORS[0], customColor: '', mount: MOUNTS[0], align: 'center', sets: 1, wall: 'light' };
  var LAYOUT = null;   // last computed layout

  /* ---------- build the form ---------- */
  function fillForm() {
    var f = $('fspl-font');
    FONT_GROUPS.forEach(function (g) {
      var og = document.createElement('optgroup'); og.label = g[0];
      g[1].forEach(function (n) { var o = document.createElement('option'); o.value = n; o.textContent = FONT_LABELS[n] || n; og.appendChild(o); });
      f.appendChild(og);
    });
    f.value = S.font;
    var t = $('fspl-thick');
    THICKS.forEach(function (th) { var o = document.createElement('option'); o.value = th; var rows = TABLE[th]; o.textContent = th + ' thick (' + fmtIn(rows[0].h) + ' to ' + fmtIn(rows[rows.length - 1].h) + ' tall)'; t.appendChild(o); });
    t.value = S.thick;
    var c = $('fspl-colors');
    COLORS.forEach(function (col, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'fspl-sw' + (i === 0 ? ' is-on' : ''); b.title = col[0]; b.setAttribute('aria-label', col[0]);
      b.style.background = col[1]; b.dataset.i = i;
      b.addEventListener('click', function () { S.color = COLORS[i]; [].forEach.call(c.children, function (x) { x.classList.toggle('is-on', x === b); }); $('fspl-color-name').textContent = col[0]; update(); });
      c.appendChild(b);
    });
    $('fspl-color-name').textContent = S.color[0];
    var m = $('fspl-mount');
    MOUNTS.forEach(function (x) { var o = document.createElement('option'); o.value = x; o.textContent = x; m.appendChild(o); });
    $('fspl-text').value = S.text; $('fspl-height').value = S.height; $('fspl-bold').checked = S.bold; $('fspl-sets').value = S.sets;
  }
  function readForm() {
    S.text = $('fspl-text').value.replace(/\r/g, '').split('\n').slice(0, 4).map(function (l) { return l.replace(/\s+$/, '').slice(0, 60); }).join('\n');
    S.font = $('fspl-font').value; S.bold = $('fspl-bold').checked && !ONE_WEIGHT[S.font];
    S.height = parseFloat($('fspl-height').value) || 0; S.thick = $('fspl-thick').value;
    S.customColor = $('fspl-custom-color').value.trim().slice(0, 80);
    S.mount = $('fspl-mount').value; S.sets = Math.max(1, Math.min(99, parseInt($('fspl-sets').value, 10) || 1));
    $('fspl-bold').disabled = !!ONE_WEIGHT[S.font];
  }

  /* ---------- pricing ---------- */
  // capital = A-Z, numbers, punctuation and symbols; lowercase = lowercase letters. Spaces are free.
  function countChars(text) {
    var cap = 0, low = 0;
    Array.from(text).forEach(function (ch) { if (/\s/.test(ch)) { return; } if (ch !== ch.toUpperCase() && ch === ch.toLowerCase()) { low++; } else { cap++; } });
    return { cap: cap, low: low };
  }
  function rowFor(thick, h) {
    var rows = TABLE[thick] || [];
    for (var i = 0; i < rows.length; i++) { if (rows[i].h >= h - 1e-9) { return rows[i]; } }
    return null;
  }
  function quote() {
    var rows = TABLE[S.thick] || [], min = rows.length ? rows[0].h : 0, max = rows.length ? rows[rows.length - 1].h : 0;
    var q = { min: min, max: max, row: null, n: countChars(S.text), err: '' };
    if (!q.n.cap && !q.n.low) { q.err = 'Type your words to see a price.'; return q; }
    if (!(S.height > 0)) { q.err = 'Enter how tall the capital letters should be.'; return q; }
    if (S.height < min) { q.err = 'At ' + S.thick + ' thick, the smallest letter is ' + fmtIn(min) + ' tall. Make the letters taller, or pick a thinner material.'; return q; }
    if (S.height > max + 1e-9) { q.err = 'For letters taller than ' + fmtIn(max) + ' at this thickness, call us for a quote.'; return q; }
    q.row = rowFor(S.thick, S.height);
    if (!q.row || (q.n.low && !q.row.low)) { q.err = 'That size is not available online. Call us for a quote.'; q.row = null; return q; }
    q.capEach = q.row.cap.price; q.lowEach = q.row.low ? q.row.low.price : 0;
    q.perSet = q.n.cap * q.capEach + q.n.low * q.lowEach;
    q.total = q.perSet * S.sets;
    return q;
  }

  /* ---------- layout: outlined paths in inches ---------- */
  function capHeightUnits(font) {
    var g = font.charToGlyph('H'), bb = g && g.getBoundingBox();
    if (bb && bb.y2 > 0) { return bb.y2; }
    return (font.tables.os2 && font.tables.os2.sCapHeight) || font.ascender * 0.7;
  }
  function layout(font) {
    var H = Math.max(S.height, 0.5);
    var size = H * font.unitsPerEm / capHeightUnits(font);   // font size in inches so a capital is H tall
    var lead = H * 1.75;                                       // baseline to baseline
    var lines = S.text.split('\n'), missing = {};
    var out = lines.map(function (line, i) {
      Array.from(line).forEach(function (ch) { if (!/\s/.test(ch) && font.charToGlyph(ch).index === 0) { missing[ch] = 1; } });
      var p = font.getPath(line, 0, i * lead, size, { kerning: true });
      var bb = p.getBoundingBox();
      return { path: p, bb: bb, adv: font.getAdvanceWidth(line, size, { kerning: true }), text: line };
    });
    var widest = Math.max.apply(null, out.map(function (l) { return l.adv; }).concat([0]));
    out.forEach(function (l) {
      var dx = S.align === 'center' ? (widest - l.adv) / 2 : S.align === 'right' ? widest - l.adv : 0;
      if (dx) { l.path.commands.forEach(function (c) { ['x', 'x1', 'x2'].forEach(function (k) { if (c[k] != null) { c[k] += dx; } }); }); l.bb = l.path.getBoundingBox(); }
    });
    var ink = out.filter(function (l) { return l.text.trim(); });
    if (!ink.length) { return null; }
    var bb = { x1: Math.min.apply(null, ink.map(function (l) { return l.bb.x1; })), y1: Math.min.apply(null, ink.map(function (l) { return l.bb.y1; })), x2: Math.max.apply(null, ink.map(function (l) { return l.bb.x2; })), y2: Math.max.apply(null, ink.map(function (l) { return l.bb.y2; })) };
    return { lines: ink, bb: bb, w: bb.x2 - bb.x1, h: bb.y2 - bb.y1, size: size, missing: Object.keys(missing) };
  }
  function pathD(p, ox, oy, k) {
    k = k || 1;
    var f = function (v) { return (Math.round(v * k * 10000) / 10000); };
    return p.commands.map(function (c) {
      var x = function (v) { return f(v - ox); }, y = function (v) { return f(v - oy); };
      switch (c.type) {
        case 'M': return 'M' + x(c.x) + ' ' + y(c.y);
        case 'L': return 'L' + x(c.x) + ' ' + y(c.y);
        case 'C': return 'C' + x(c.x1) + ' ' + y(c.y1) + ' ' + x(c.x2) + ' ' + y(c.y2) + ' ' + x(c.x) + ' ' + y(c.y);
        case 'Q': return 'Q' + x(c.x1) + ' ' + y(c.y1) + ' ' + x(c.x) + ' ' + y(c.y);
        default: return 'Z';
      }
    }).join('');
  }

  /* ---------- preview ---------- */
  function preview(L) {
    var box = $('fspl-preview');
    if (!L) { box.innerHTML = '<p class="fspl-empty">Type your words to see them here.</p>'; box.style.background = ''; return; }
    var pad = Math.max(L.h * 0.9, 6), W = L.w + pad * 2, Hh = L.h + pad * 2 + L.h * 0.5;
    var ox = L.bb.x1 - pad, oy = L.bb.y1 - pad;
    var dark = S.wall === 'dark', wall = dark ? '#2b2f33' : '#e9e6e1';
    var fill = S.color[1], edge = shade(fill, -0.35), sh = Math.max(S.height * 0.035, 0.08);
    var d = L.lines.map(function (l) { return pathD(l.path, ox, oy); }).join('');
    var dimY = L.h + pad + L.h * 0.25, tick = L.h * 0.08, fs = Math.max(L.h * 0.16, 0.9);
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + r1(W) + ' ' + r1(Hh) + '" role="img" aria-label="Preview of your letters">' +
      '<rect width="100%" height="100%" fill="' + wall + '"/>' +
      '<path d="' + d + '" fill="rgba(0,0,0,' + (dark ? 0.55 : 0.22) + ')" transform="translate(' + sh * 1.6 + ' ' + sh * 1.6 + ')"/>' +
      '<path d="' + d + '" fill="' + edge + '" transform="translate(' + sh * 0.6 + ' ' + sh * 0.6 + ')"/>' +
      '<path d="' + d + '" fill="' + fill + '" stroke="' + edge + '" stroke-width="' + r1(sh * 0.25) + '"/>' +
      '<g stroke="' + (dark ? '#cfd6dc' : '#4a5763') + '" stroke-width="' + r1(fs * 0.06) + '" fill="none">' +
      '<path d="M' + r1(pad) + ' ' + r1(dimY) + 'H' + r1(pad + L.w) + 'M' + r1(pad) + ' ' + r1(dimY - tick) + 'V' + r1(dimY + tick) + 'M' + r1(pad + L.w) + ' ' + r1(dimY - tick) + 'V' + r1(dimY + tick) + '"/></g>' +
      '<text x="' + r1(pad + L.w / 2) + '" y="' + r1(dimY + fs * 1.3) + '" font-size="' + r1(fs) + '" text-anchor="middle" font-family="Arial,sans-serif" fill="' + (dark ? '#e7ecf0' : '#1c2430') + '">About ' + r1(L.w) + '" wide x ' + r1(L.h) + '" tall overall</text>' +
      '</svg>';
    box.innerHTML = svg; box.style.background = wall;
  }
  function shade(hex, amt) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    var f = function (c) { return Math.max(0, Math.min(255, Math.round(amt < 0 ? c * (1 + amt) : c + (255 - c) * amt))); };
    if (r + g + b > 720) { return '#b8b8b8'; }
    return '#' + ((1 << 24) + (f(r) << 16) + (f(g) << 8) + f(b)).toString(16).slice(1);
  }

  /* ---------- price box ---------- */
  function showPrice(q) {
    var box = $('fspl-price'), btn = $('fspl-cart');
    if (q.err) { box.innerHTML = '<p class="fspl-warn">' + esc(q.err) + '</p>'; btn.disabled = true; return; }
    var exact = Math.abs(q.row.h - S.height) < 1e-9;
    var lines = [];
    if (q.n.cap) { lines.push('<tr><td>' + q.n.cap + ' capital' + (q.n.cap > 1 ? 's' : '') + ', numbers &amp; symbols at ' + money(q.capEach) + '</td><td>' + money(q.n.cap * q.capEach) + '</td></tr>'); }
    if (q.n.low) { lines.push('<tr><td>' + q.n.low + ' lowercase letter' + (q.n.low > 1 ? 's' : '') + ' at ' + money(q.lowEach) + '</td><td>' + money(q.n.low * q.lowEach) + '</td></tr>'); }
    if (S.sets > 1) { lines.push('<tr><td>Price for one set</td><td>' + money(q.perSet) + '</td></tr><tr><td>&times; ' + S.sets + ' sets</td><td></td></tr>'); }
    box.innerHTML = '<p class="fspl-size">' + esc(S.thick) + ' thick ' + NOUN + ', ' + (exact ? fmtIn(q.row.h) + ' tall capitals' : 'priced as ' + fmtIn(q.row.h) + ' letters (the next size up from ' + fmtIn(S.height) + ')') + '</p>' +
      '<table class="fspl-tbl">' + lines.join('') + '<tr class="fspl-total"><td>Total</td><td>' + money(q.total) + '</td></tr></table>' +
      '<p class="fspl-fine">Spaces are free. Mounting hardware and a full-size install pattern are included. Shipping is added at checkout; the minimum order is $50. Typical turnaround is 2 to 4 weeks after you approve your proof.</p>';
    btn.disabled = false;
  }

  /* ---------- update ---------- */
  var tick = 0;
  function update() {
    readForm();
    var my = ++tick, w = S.bold ? 700 : 400;
    var q = quote();
    showPrice(q);
    var hint = $('fspl-height-hint');
    if (q.row && Math.abs(q.row.h - S.height) > 1e-9) { hint.textContent = 'Our price table goes up in steps. ' + fmtIn(S.height) + ' is priced at ' + fmtIn(q.row.h) + '. You can make them ' + fmtIn(q.row.h) + ' tall for the same price.'; hint.hidden = false; }
    else { hint.hidden = true; }
    return loadFont(S.font, w).then(function (font) {
      if (my !== tick) { return; }
      LAYOUT = layout(font);
      preview(LAYOUT);
      var warn = $('fspl-warn');
      var msgs = [];
      if (LAYOUT && LAYOUT.missing.length) { msgs.push('This font does not have: ' + LAYOUT.missing.join(' ') + '. Pick another font or leave those out.'); }
      if (LAYOUT && LAYOUT.w > 240) { msgs.push('At about ' + r1(LAYOUT.w) + '" wide, this is a big job. We will confirm the layout with you before we make it.'); }
      warn.innerHTML = msgs.map(function (m) { return '<p>' + esc(m) + '</p>'; }).join(''); warn.hidden = !msgs.length;
      if (LAYOUT && LAYOUT.missing.length) { $('fspl-cart').disabled = true; }
    }).catch(function (e) { $('fspl-preview').innerHTML = '<p class="fspl-empty">Sorry, the font did not load (' + esc(e.message) + '). Please try another font or call us.</p>'; });
  }

  /* ---------- production files ---------- */
  var PDF_MAX = 199;  // inches; bigger layouts are drawn at half scale (noted on the order)
  function buildFiles() {
    var w = S.bold ? 700 : 400;
    return loadFont(S.font, w).then(function (font) {
      var L = layout(font);
      if (!L) { throw new Error('Type your words first.'); }
      var m = 1, W = L.w + 2 * m, H = L.h + 2 * m;
      var half = W > PDF_MAX || H > PDF_MAX, k = half ? 0.5 : 1;
      var ox = L.bb.x1 - m, oy = L.bb.y1 - m;
      // SVG: real inches (viewBox in inches), black filled outlines, one path per line
      var svg = '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="' + r1(W * k * 1000) / 1000 + 'in" height="' + r1(H * k * 1000) / 1000 + 'in" viewBox="0 0 ' + (W * k).toFixed(4) + ' ' + (H * k).toFixed(4) + '">\n' +
        '<!-- ' + esc(VERSION) + (half ? ' HALF SCALE: print/cut at 200%' : ' full size') + '. Capital height ' + S.height + ' in. -->\n' +
        L.lines.map(function (l, i) { return '<path id="line-' + (i + 1) + '" d="' + pathD(l.path, ox, oy, k) + '" fill="#000000"/>'; }).join('\n') + '\n</svg>\n';
      // PDF: same outlines in points
      var PL = window.PDFLib;
      return PL.PDFDocument.create().then(function (doc) {
        var pt = 72 * k, pw = W * pt, ph = H * pt;
        var page = doc.addPage([pw, ph]);
        L.lines.forEach(function (l) { page.drawSvgPath(pathD(l.path, ox, oy, pt), { x: 0, y: ph, color: PL.rgb(0, 0, 0), borderWidth: 0 }); });
        doc.setTitle('Letters: ' + S.text.replace(/\n/g, ' / ')); doc.setCreator(VERSION); doc.setProducer(VERSION);
        return doc.save();
      }).then(function (bytes) {
        return previewJpg().then(function (jpg) {
          var id = 'L' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();
          var base = 'letters-' + id;
          return {
            id: id, layout: L, half: half,
            pdf: new File([bytes], base + '.pdf', { type: 'application/pdf' }),
            svg: new File([svg], base + '.svg', { type: 'image/svg+xml' }),
            jpg: jpg ? new File([jpg], base + '-preview.jpg', { type: 'image/jpeg' }) : null
          };
        });
      });
    });
  }
  function previewJpg() {
    var el = $('fspl-preview').querySelector('svg');
    if (!el) { return Promise.resolve(null); }
    var vb = el.viewBox.baseVal, scale = Math.min(1600 / vb.width, 1000 / vb.height);
    var cw = Math.round(vb.width * scale), ch = Math.round(vb.height * scale);
    var src = new XMLSerializer().serializeToString(el).replace('<svg ', '<svg width="' + cw + '" height="' + ch + '" ');
    return new Promise(function (res) {
      var img = new Image();
      img.onload = function () { var c = document.createElement('canvas'); c.width = cw; c.height = ch; c.getContext('2d').drawImage(img, 0, 0); c.toBlob(function (b) { res(b); }, 'image/jpeg', 0.88); };
      img.onerror = function () { res(null); };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(src);
    });
  }

  /* ---------- cart ---------- */
  function status(msg, warn) { var s = $('fspl-status'); s.textContent = msg; s.classList.toggle('is-warn', !!warn); }
  function addToCart() {
    readForm();
    var q = quote();
    if (q.err) { status(q.err, true); return; }
    if (!$('fspl-ok').checked) { status('Please tick the box to confirm you checked the spelling and the size.', true); $('fspl-ok').closest('label').classList.add('is-missing'); return; }
    var btn = $('fspl-cart'); btn.disabled = true; status('Making your layout file…');
    var colorText = S.color[0] + (S.customColor ? ' (match: ' + S.customColor + ')' : '');
    buildFiles().then(function (f) {
      var L = f.layout, words = S.text.replace(/\n/g, ' / ');
      var overall = r1(L.w) + '"W x ' + r1(L.h) + '"H';
      var exact = Math.abs(q.row.h - S.height) < 1e-9;
      var common = {
        'Words': words,
        'Font': S.font + (S.bold ? ' Bold' : ''),
        'Letter height': fmtIn(S.height) + ' capitals' + (exact ? '' : ' (priced at ' + fmtIn(q.row.h) + ')'),
        'Thickness': S.thick + ' ' + MATERIAL,
        'Color': colorText,
        'Mounting': S.mount,
        'Overall size': 'About ' + overall + (S.sets > 1 ? ' per set, ' + S.sets + ' sets' : ''),
        '_Letter set ID': f.id
      };
      var note = 'LETTERS (' + NOUN + '): "' + words + '" in ' + common.Font + ', capital height ' + S.height + ' in (table row ' + q.row.h + ' in), ' + S.thick + ' thick, color ' + colorText + ', ' + S.mount + ', ' + q.n.cap + ' capitals/numbers/symbols + ' + q.n.low + ' lowercase per set x ' + S.sets + ' set(s), overall ' + overall + (f.half ? '. FILE IS HALF SCALE: cut at 200%' : '. File is full size') + '. Align: ' + S.align + '.';
      var parts = [];
      if (q.n.cap) { parts.push({ v: q.row.cap, qty: q.n.cap * S.sets, kind: 'Capitals, numbers & symbols' }); }
      if (q.n.low) { parts.push({ v: q.row.low, qty: q.n.low * S.sets, kind: 'Lowercase letters' }); }
      status('Adding to your cart…');
      var chain = Promise.resolve(), added = 0;
      parts.forEach(function (p, i) {
        chain = chain.then(function () {
          var fd = new FormData();
          fd.append('id', p.v.id); fd.append('quantity', p.qty);
          fd.append('properties[Letters in this line]', p.kind + ': ' + (p.qty / S.sets) + (S.sets > 1 ? ' per set x ' + S.sets : ''));
          Object.keys(common).forEach(function (k) { fd.append('properties[' + k + ']', common[k]); });
          if (i === 0) {
            if (f.jpg) { fd.append('properties[Preview]', f.jpg); }
            fd.append('properties[_Layout PDF (outlined)]', f.pdf);
            fd.append('properties[_Layout SVG]', f.svg);
            fd.append('properties[_Print notes]', note);
          } else {
            fd.append('properties[_Print notes]', 'Same letter set as ' + f.id + ' (files are on the capitals line).');
          }
          fd.append('properties[_Designer]', VERSION);
          return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).then(function (res) {
            return res.json().then(function (j) { if (!res.ok) { throw new Error(j.description || j.message || ('HTTP ' + res.status)); } added++; return j; });
          });
        });
      });
      return chain.then(function () {
        window.FSPL_LAST = { id: f.id, files: f, parts: parts.map(function (p) { return { id: p.v.id, qty: p.qty }; }) };
        status('Added to your cart.');
        if (!window.FSPL_NO_REDIRECT) { window.location.href = '/cart'; } else { btn.disabled = false; }
      }).catch(function (e) {
        window.FSPL_ERROR = e;
        btn.disabled = false;
        status((added ? 'Part of your order was added, but not all of it. Please check your cart or call us. ' : 'Sorry, we could not add this to your cart. ') + '(' + e.message + ')', true);
      });
    }).catch(function (e) { window.FSPL_ERROR = e; btn.disabled = false; status('Sorry, something went wrong: ' + e.message, true); });
  }

  /* ---------- wire up ---------- */
  fillForm();
  ['fspl-text', 'fspl-height', 'fspl-custom-color', 'fspl-sets'].forEach(function (id) { $(id).addEventListener('input', update); });
  ['fspl-font', 'fspl-thick', 'fspl-mount', 'fspl-bold'].forEach(function (id) { $(id).addEventListener('change', update); });
  [].forEach.call(root.querySelectorAll('[data-align]'), function (b) { b.addEventListener('click', function () { S.align = b.dataset.align; [].forEach.call(root.querySelectorAll('[data-align]'), function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); }); update(); }); });
  [].forEach.call(root.querySelectorAll('[data-wall]'), function (b) { b.addEventListener('click', function () { S.wall = b.dataset.wall; [].forEach.call(root.querySelectorAll('[data-wall]'), function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); }); preview(LAYOUT); }); });
  $('fspl-ok').addEventListener('change', function () { this.closest('label').classList.remove('is-missing'); });
  $('fspl-cart').addEventListener('click', addToCart);
  window.FSPL = { ready: update(), state: S, quote: quote, buildFiles: buildFiles, table: TABLE, countChars: countChars, version: VERSION, update: update };
})();
